import { useEffect, useState } from 'react';
import {
    Button,
    Form,
    Input,
    Select,
    Table,
    Tag,
    Tooltip,
    Dropdown,
    Menu,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import DataSubject360Service from '../../../services/DataSubject360.service';
import Globalservice from '../../../services/Global.service';
const { Option } = Select;

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

export default function ListCard({
    requestList,
    setKeyword,
    setRequestTypeId,
    tab,
    selectPeriod,
    period,
    keyword,
    requestTypeId,
    currentPage,
    setCurrentPage,
    setLoading,
}) {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();

    let lang = i18n.language;

    const [requestType, setRequestType] = useState([]);

    const columns = [
        {
            title: t('Dashboard360.RequestID'),
            dataIndex: 'requestId',
            key: 'requestId',
            sorter: true,
        },
        {
            title: t('Dashboard360.DataSubject'),
            dataIndex: 'dataSubjectName',
            key: 'dataSubjectName',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Dashboard360.RequestTypeTable'),
            dataIndex: 'dsTypeShortName',
            key: 'dsTypeShortName',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Dashboard360.Status'),
            dataIndex: 'status',
            key: 'status',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <div className="text-center">
                        {_getTagRequest(row?.status, row?.status)}
                    </div>
                );
            },
        },
        {
            title: t('Dashboard360.DayLeft'),
            dataIndex: 'dayLeft',
            key: 'dayLeft',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <div className="text-center">
                        {row?.status !== 'Done' &&
                        row?.status !== 'Reject' &&
                        row?.status !== 'Rejected' &&
                        row?.status !== 'Archived'
                            ? _getTagDay(value)
                            : '-'}
                    </div>
                );
            },
        },
        {
            title: t('Dashboard360.Domain'),
            dataIndex: 'domainName',
            key: 'domainName',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Dashboard360.IPAddress'),
            dataIndex: 'ipAddress',
            key: 'ipAddress',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Dashboard360.Extended'),
            dataIndex: 'extend',
            key: 'extend',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <>
                        {value === '-' ? (
                            <>{value}</>
                        ) : (
                            <div className="font-semibold text-[#F0536F]">
                                {value}
                            </div>
                        )}
                    </>
                );
            },
        },
        {
            title: t('Dashboard360.RequestDate'),
            dataIndex: 'requestDate',
            key: 'requestDate',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <>
                        {value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'}
                    </>
                );
            },
        },
    ];

    const _getTagDay = (e) => {
        if (e <= 0) {
            return (
                <Tag className="rounded-xl -my-1" color="#F0536F">
                    {e}
                </Tag>
            );
        } else if (e <= 7) {
            return (
                <Tag className="rounded-xl -my-1" color="#F9C153">
                    {e}
                </Tag>
            );
        } else if (e > 30) {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    <div className="flex items-center gap-x-1">
                        <div>{e}</div>
                        <Tooltip
                            className="cursor-pointer"
                            placement="right"
                            title={
                                <div className="whitespace-pre-line">
                                    {t('MyTask.TooltipExtendDayLeft')}
                                </div>
                            }
                        >
                            <div className="text-xs">
                                <InfoCircleOutlined />
                            </div>
                        </Tooltip>
                    </div>
                </Tag>
            );
        } else {
            return (
                <Tag className="rounded-xl -my-1" color="#1890FF">
                    {e}
                </Tag>
            );
        }
    };

    const _getTagRequest = (nameEn, nameTh) => {
        if (nameEn === 'New') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Verified') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#7B67FB', borderColor: '#7B67FB' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Assigned') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Preparing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'In Progress') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Archived') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Reject') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en'
                        ? 'Rejected'
                        : nameTh === 'Reject'
                        ? 'Rejected'
                        : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    useEffect(() => {
        form.resetFields();
        setKeyword('');
        setRequestTypeId('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab]);

    const onFinish = async (value) => {
        console.log(value);
    };
    const onChange = async (e) => {
        console.log('onChange >>> ', e.target.value);
        setKeyword(e.target.value);
        setLoading(true);
        setCurrentPage({
            page: 1,
            pageSize: 10,
            sortBy: 'requestDate',
            sortDirection: 'DESC',
            total: 0,
        });
    };

    useEffect(() => {
        const getRequestType = async () => {
            const { data } = await Globalservice.getRequestType();
            const item = data?.resultData;
            setRequestType(item);
        };
        getRequestType();
    }, []);

    const onRequestTypeChange = async (value) => {
        console.log('onRequestTypeChange >>>> ', value);
        setRequestTypeId(value);
        setLoading(true);
        setCurrentPage({
            page: 1,
            pageSize: 10,
            sortBy: 'requestDate',
            sortDirection: 'DESC',
            total: 0,
        });
    };

    const exportDS360 = async (type) => {
        const payload = {
            period: period, //Last 7 Days,Monthly,Yearly
            month: period === 'Monthly' ? selectPeriod : currentMonth + 1, //1 = january
            year: period === 'Yearly' ? selectPeriod : currentYear,
            keyword: keyword,
            requestTypeId: requestTypeId,
            exportType: type,
            s: 'DESC',
            sd: 'requestDate',
        };
        const time = moment(new Date()).format('YYYY-MM-DD');
        try {
            const { data } = await DataSubject360Service.exportDS360(payload);
            if (data && type === 'xlsx') {
                const objectURL = URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = `DS360_Report_${time}.${type}`;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            } else {
                let reader = new FileReader();
                reader.onload = function () {
                    const link = document.createElement('a');
                    let universalBOM = '\uFEFF';
                    link.setAttribute(
                        'href',
                        'data:text/csv; charset=utf-8,' +
                            encodeURIComponent(universalBOM + reader.result)
                    );
                    link.setAttribute(
                        'download',
                        `DS360_Report_${time}.${type}`
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                };
                reader.readAsText(data);
                // const objectURL = URL.createObjectURL(new Blob([data]));

                // link.href = objectURL;
                // link.download = `DS360_Report_${time}.${type}`;
            }
        } catch (error) {
            console.log(error);
        }
    };

    const menu = (
        <Menu style={{ borderRadius: '6px' }}>
            {/* <Menu.ItemGroup className='p-2' style={{borderBottom: '1px solid #ECECEC'}} title="เลือกไฟล์ที่ต้องการ Export"/> */}
            <Menu.Item
                className={`p-4`}
                onClick={() => {
                    exportDS360('csv');
                }}
                key="lastPublic"
            >
                ไฟล์ .CSV
            </Menu.Item>
            <Menu.Item
                className="p-4"
                onClick={() => {
                    exportDS360('xlsx');
                }}
                key="lastEdit"
            >
                ไฟล์ .xlsx
            </Menu.Item>
        </Menu>
    );

    const paginationProps = {
        current: parseInt(currentPage.page),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'requestDate',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'ASC'
                        : 'DESC'
                    : 'DESC',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setLoading(true);
        setCurrentPage(pageValues);
        // getAllLandlordAdmin(searchValue, pageValues);
    };

    return (
        <>
            <div
                className="my-4"
                style={{ borderBottom: ' 2px solid #F5F6FF' }}
            ></div>
            <div className="col-span-12 mt-6">
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <div className="grid grid-cols-8 gap-4">
                        <div className="col-span-2">
                            <Form.Item className="w-full mb-0'" name="keyWord">
                                <Input
                                    prefix={
                                        <SearchOutlined className="site-form-item-icon" />
                                    }
                                    placeholder={t(
                                        'Dashboard360.SearchRequestID'
                                    )}
                                    size="large"
                                    onChange={onChange}
                                    allowClear
                                />
                            </Form.Item>
                        </div>
                        <div className="col-span-2">
                            <Form.Item
                                name="requestType"
                                className="w-full mb-0"
                            >
                                <Select
                                    size="large"
                                    onChange={onRequestTypeChange}
                                    placeholder={t(
                                        'Dashboard360.SearchRequestType'
                                    )}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {requestType?.map((e) => (
                                        <Option
                                            key={e.requestTypeId}
                                            value={e.requestTypeId}
                                        >
                                            {lang === 'en'
                                                ? e.requestTypeShortName
                                                : e.requestTypeShortName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-span-4 text-right">
                            <Dropdown
                                trigger={['click']}
                                overlayStyle={{ width: '255px' }}
                                overlay={menu}
                                placement="bottomRight"
                            >
                                <Button
                                    // icon={<DownloadOutlined />}
                                    className="px-9"
                                    type="primary"
                                    size="large"
                                >
                                    {t('common.Export')}
                                </Button>
                            </Dropdown>
                        </div>
                    </div>
                </Form>
            </div>
            <div className="col-span-12 mt-2 min-h-[54vh] ">
                <Table
                    className="inbox_table"
                    dataSource={requestList}
                    // columns.filter(col => col.dataIndex !== 'id')
                    columns={
                        tab !== '5' && tab !== '6' && tab !== '7'
                            ? columns
                            : columns.filter(
                                  (col) => col.dataIndex !== 'dayLeft'
                              )
                    }
                    pagination={paginationProps}
                    onChange={onPageChange}
                />
            </div>
            {/* <div className="col-span-12 w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div> */}
        </>
    );
}
